module.exports = __webpack_public_path__ + "img/buildings.b7556029.svg";